import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ProductCard from "@/components/ProductCard";
import { Button } from "@/components/ui/button";

export default function Favorites() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user === false) { navigate("/login?next=/favorites"); return; }
    if (!user || !user.id) return;
    setLoading(true);
    api.get("/favorites")
      .then(({ data }) => setItems(data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [user, navigate]);

  if (!user || !user.id) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 fade-in">
      <h1 className="font-display text-3xl">{t("nav.favorites")}</h1>

      <div className="mt-8">
        {loading ? (
          <div className="text-sm text-muted-foreground">{t("messages.loading")}</div>
        ) : items.length === 0 ? (
          <div className="py-20 text-center">
            <div className="font-display text-lg">{t("profile.empty_favorites")}</div>
            <Button onClick={() => navigate("/")} className="mt-5 rounded-full">{t("profile.cta_browse")}</Button>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6" data-testid="favorites-grid">
            {items.map((it) => <ProductCard key={it.id} item={it} />)}
          </div>
        )}
      </div>
    </div>
  );
}
